import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgScreeningDeviceSieveStrainerBasketReel = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 80,
	height: 180,
	viewBox: "0 0 80.0 180.0",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M 0.0 0.0 L 80.0 0.0 L 80.0 140.0 L 40.0 180.0 L 0.0 140.0 Z",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 40,
			cy: 25,
			rx: 10,
			ry: 10,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 40,
			cy: 125,
			rx: 10,
			ry: 10,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 30.0 25.0 L 30.0 125.0 M 50.0 25.0 L 50.0 125.0 M 50.0 40.0 A 20.0 20.0 0.0 0 1 70.0 60.0 M 50.0 85.0 A 20.0 20.0 0.0 0 1 70.0 105.0 M 30.0 60.0 A 20.0 20.0 0.0 0 1 10.0 40.0 M 30.0 105.0 A 20.0 20.0 0.0 0 1 10.0 85.0",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1,
			strokeDasharray: "2 2"
		})
	]
});
export default SvgScreeningDeviceSieveStrainerBasketReel;
